<template>
  <div>
    <div class="d-inline-block">
      <div v-if="!moreOption">

        <!--        <b-form-checkbox class="mb-1" v-model="selectAll" :value="true" :unchecked-value="false"-->
        <!--                         @input="selectAllOptions">-->
        <!--          {{ selectAll ? 'Deselect' : 'Select' }} All-->
        <!--        </b-form-checkbox>-->

        <treeselect class="filter-select d-inline-block" v-model="filterSelectedValues" multiple :options="sortedValues"
                    :disabled="isLoading"
                    :normalizer="(node) => {return {id: node, label: node}}"
                    @input="emitChanges"
                    @search-change="searchOptions"
        >
          <template v-slot:before-list>
            <span>
              <small class="text-muted" style="margin-left: 1em"
                     v-if="sortedValues.length < values.length" kjmnj
              >Showing {{ sortedValues.length }} of {{ values.length }} loaded values</small> 
              &nbsp;
              <small
                  v-if="isMany || searchedBefore"
                  class="search-button"
                  @click="initiateSearch"
                  title="Only 10,000 values can be loaded at the same time. Click here to search from datasource if the values are not in the list."
              >Search for more</small>
            </span>

          </template>
        </treeselect>
<!--        <b-button v-if="this.filterSelectedValues.length" class="align-top ml-2 mt-1" size="sm"-->
        <!--                  variant="outline-primary" @click="()=>{this.filterSelectedValues = [];}">Clear-->
        <!--        </b-button>-->
      </div>
      <div v-else>
        <b-form-textarea class="filter-text mb-2" v-model="textCommaSeperatedValues" @change="textUpdate"
                         placeholder="Manually write comma separated values"/>
        <b-form-file v-model="uploadedFile" size="sm" class="btn-file-upload"/>
        <small class="text-muted">{{ textSelectedValues.length }} values selected</small>
      </div>
    </div>

    <b-button class="align-top ml-3" size="sm" variant="light" @click="changeOption">
      <b-icon v-if="!moreOption" icon="file-earmark-arrow-up" variant="primary" title="Upload file to filter"/>
      <b-icon v-else icon="card-list" variant="primary" title="Use the drop down list"/>
    </b-button>


    <b-modal ref="searchModal" hide-header button-size="sm" ok-title="Search" @ok.prevent="search" centered>
      <b-form ref="searchForm" @submit.prevent.stop="search">
        <b-form-input v-model="searchText" required></b-form-input>
      </b-form>

    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import XLSX from "xlsx";

const MAX_LENGTH = 10;
const IS_MANY = 9999;
export default {
  name: "BqFilterSelect",
  props: {
    value: Array,
    values: Array,
    isLoading: Boolean,
    approxCount: Number
  },
  mounted() {
    this.filterSelectedValues = this.value;
    this.moreOption = this.isMany;
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.filterSelectedValues = this.value;
      }
    },
    uploadedFile(newUploadedFile) {
      const reader = new FileReader();
      const file = newUploadedFile;
      if (file.name) {
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (!regex.test(file.name.toLowerCase())) {
          this.$bvToast.toast(
              `Only xlsx and xls files are accepted. Please upload again.`,
              {
                title: 'File format',
                variant: 'warning',
                autoHideDelay: 5000,
                appendToast: true
              }
          );
        }

        reader.onload = (e) => {
          try {
            let buffer = e.target.result;
            let uint8Arr = new Uint8Array(buffer);
            let data = '';
            for (var i = 0; i < uint8Arr.byteLength; i++) {
              data += String.fromCharCode(uint8Arr[i]);
            }
            //Read the workbook as array
            let wb = XLSX.read(data, {type: 'binary'});
            //Get the first Worksheet
            let ws = wb.Sheets[wb.SheetNames[0]];
            //Convert the first worksheet to csv (no comma because only the first column is used)
            let csv = XLSX.utils.sheet_to_csv(ws);
            let csvArr = csv.split('\n');
            csvArr = _.map(csvArr, (row) => {
              return row.split(',')[0].trim().substring(0, 100);
            });
            csvArr = _.uniq(csvArr);
            csvArr = csvArr.filter(Boolean);
            this.textSelectedValues = csvArr;
            this.textCommaSeperatedValues = csvArr.join(',');
            this.emitChanges();
          } catch (e) {
            this.$bvToast.toast(
                `Failed to process the uploaded file. Please try again.`,
                {
                  title: 'Failed to load.',
                  variant: 'warning',
                  autoHideDelay: 5000,
                  appendToast: true
                }
            );
          }
        };

        reader.readAsArrayBuffer(file);
      }
    },
  },
  data() {
    return {
      maxLength: MAX_LENGTH,
      filterSelectedValues: [],

      textSelectedValues: [],
      textCommaSeperatedValues: '',
      searchText: '',
      searchedBefore: false,
      moreOption: false,

      uploadedFile: null,
      selectAll: false,
    }
  },
  computed: {
    sortedValues() {
      let options = _.filter(this.values, (v) => {
        return Boolean(v);
      });
      if (this.searchText) {
        options = _.filter(options, (v) => {
          return (v).includes(this.searchText);
        });
      }
      options = _.orderBy(options);

      return options.slice(0, 50);
    },
    isMany() {
      return this.approxCount > IS_MANY || this.values.length >= IS_MANY;
    }
  },
  methods: {
    initiateSearch() {
      this.searchText = '';
      this.$refs.searchModal.show();
    },
    search() {
      const form = this.$refs.searchForm;
      if (!form.reportValidity()) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.searchModal.hide();
      })
      this.searchedBefore = true;
      this.$emit('search', this.searchText);
    },
    selectAllOptions() {
      if (this.selectAll) {
        this.filterSelectedValues = [...this.values];
      } else {
        this.filterSelectedValues = [];
      }
      this.emitChanges();
    },
    changeOption() {
      const currentOption = this.moreOption;
      if (currentOption) {
        this.filterSelectedValues = [];
      }
      this.moreOption = !currentOption;
      this.emitChanges();
    },
    textUpdate() {
      let values = this.textCommaSeperatedValues
          .replace(/[^0-9a-z, -]/gi, '')
          .split(',');
      values = _.map(values, (v) => {
        return v.trim().substring(0, 100);
      });
      values = _.uniq(values);
      this.textSelectedValues = values.filter(Boolean);
      this.textCommaSeperatedValues = values.join(',');
      this.emitChanges();
    },
    emitChanges() {
      let selectedValues = [...this.filterSelectedValues];

      if (this.moreOption) {
        selectedValues = [...this.textSelectedValues];
      }

      this.$emit('input', selectedValues)
    },
    searchOptions(text) {
      this.searchText = text;
    }
  }
}
</script>

<style scoped>
.search-button {
  color: #007bff;
  cursor: pointer;
}

.filter-select {
  width: 400px;
}

.filter-text {
  width: 400px;
  height: 80px;
}

.btn-file-upload {
  width: 200px;
  margin-right: 1rem;
}
</style>